import React from "react";
import { NavLink } from "react-router-dom";

// Reusable team member card component
const TeamMemberCard = ({ image, name, role, description, link }) => (
  <div className="col-md-4 col-lg-3 mb-4">
    <div className="team-member-card h-100 text-center p-3 border rounded shadow-sm">
      <img src={image} alt={name} className="team-photo img-fluid rounded mb-3" />
      <div className="card-body">
        <h4 className="title">{name}</h4>
        <p className="role text-muted">{role}</p>
        <p className="description">{description || "Profile details coming soon."}</p>
        <NavLink to={link} className="btn btn-outline-primary mt-2">
          View Profile
        </NavLink>
      </div>
    </div>
  </div>
);

export default function OurTeam() {
  return (
    <section className="section-team py-5">
      <div className="container">
        {/* Header Section */}
        <div className="text-center mb-5">
          <h2 className="display-6">Meet <strong>Our</strong> Team</h2>
          <p className="lead">
            Our team consists of skilled professionals dedicated to delivering exceptional results.
          </p>
        </div>

        {/* Team Members */}
        <div className="row">
          <TeamMemberCard
            image="/assets/team/AnandS.jpg"
            name="Anand Samudra"
            role="Founder & Managing Director"
            description="Anand is a visionary leader with over 15 years of experience in the IT industry, guiding our company to success. Strategic Technology Visionary Driving Digital Transformation, Fostering Innovation, and Propelling Technological Excellence in Organization."
            link="/team/AnandS"
          />

          <TeamMemberCard
            image="/assets/team/SachinB2.jpg"
            name="Sachin Bhandwalkar"
            role="Chief Cyber Security Officer (CCSO)"
            description="Mr. Sachin Bhandwalkar is a highly respected cybersecurity expert with over a decade of experience. As a certified trainer and consultant, he has made significant contributions to cybersecurity."
            link="/team/SachinB"
          />

          <TeamMemberCard
            image="/assets/team/SunitaS.png"
            name="Ms. Sunita Samudra"
            role="Director (Cheif buisness Officer)"
            description="Strategic leader driving business growth and innovation. Expert in developing partnerships, optimizing operations, and steering company vision to maximize market impact and profitability."
            link="/team/SunitaS"
          />
          
          <TeamMemberCard
            image="/assets/team/bytlas1.png"
            name="Power BI & Excel Trainer"
            role="Advanced Excel, VBA Macros Expert"
            description="Expert in empowering teams with advanced data visualization and analysis skills. Skilled at simplifying complex concepts to help users harness the full power of Power BI and Excel for smarter decision-making."
            link="/team/A"
          />

          <TeamMemberCard
            image="/assets/team/bytlas1.png"
            name="Training & Development Consultant"
            role="Senior Consultant"
            description="Specializes in designing and delivering tailored learning programs that boost employee skills and drive organizational performance. Skilled in identifying training needs and fostering continuous professional growth."
            link="/team/A"
          />

          <TeamMemberCard
            image="/assets/team/bytlas1.png"
            name="DBA"
            role="Database Administrator"
            description="Skilled in ensuring database reliability, security, and peak performance. Expert at managing data integrity, optimizing queries, and maintaining backup and recovery systems to support seamless business operations.."
            link="/team/A"
          />

          <TeamMemberCard
            image="/assets/team/bytlas1.png"
            name="Senior Programmer"
            role="Senior Programmer"
            description="Experienced in developing robust, scalable software solutions. Expert in writing clean, efficient code and mentoring teams to deliver high-quality applications on time."
            link="/team/A"
          />

          <TeamMemberCard
            image="/assets/team/bytlas1.png"
            name="Junior Programmer"
            role="Junior Programmer"
            description="Enthusiastic developer skilled in coding fundamentals and eager to contribute to software projects. Quick learner dedicated to writing reliable code and growing technical expertise."
            link="/team/A"
          />


        </div>
      </div>
    </section>
  );
}
